import type { Slide, TextProps } from '@features/powerpoint';
import { contentSlideHeaderV2 } from '../utils/slide-header-v2';
import { parsedTakeawaysV2 } from '../domain/key-takeaways-v2';
import { themeV2 } from '../domain/theme-v2';
import { DEFAULT_FONT } from '../utils/constants-v2';

type ExecutiveSummarySlideV2Props = {
  slideMaster: string;
  rsaKeyTakeaways: string[];
  ftaKeyTakeaways: string[];
};

const sectionTitle = (title: string, y: number): TextProps => ({
  text: title,
  options: {
    bold: true,
    fontSize: 18,
    fontFace: DEFAULT_FONT,
    color: themeV2.colors.metricBlue,
    h: 0.4,
    w: 11.98,
    x: 0.33,
    y,
  },
});

const bulletList = (takeaways: string[], y: number, h: number): TextProps => ({
  text: parsedTakeawaysV2(takeaways),
  options: {
    h,
    w: 11.98,
    x: 0.33,
    y,
    valign: 'top',
    paraSpaceAfter: 5,
    fontSize: 16,
    fontFace: DEFAULT_FONT,
  },
});

export const executiveSummarySlideV2 = (
  props: ExecutiveSummarySlideV2Props
): Slide => {
  const rsaTakeaways = props.rsaKeyTakeaways.filter(t => t.length > 0);
  const ftaTakeaways = props.ftaKeyTakeaways.filter(t => t.length > 0);
  const hasBothSections = rsaTakeaways.length > 0 && ftaTakeaways.length > 0;
  const ftaY = hasBothSections ? 4.2 : 1.5;

  return {
    slideMaster: props.slideMaster,
    texts: [
      contentSlideHeaderV2('Executive Summary'),
      ...(rsaTakeaways.length > 0
        ? [
            sectionTitle('Sales Lift', 1.5),
            bulletList(rsaTakeaways, 1.9, hasBothSections ? 2.2 : 4.5),
          ]
        : []),
      ...(ftaTakeaways.length > 0
        ? [
            sectionTitle('Visit Lift', ftaY),
            bulletList(ftaTakeaways, ftaY + 0.4, 2.5),
          ]
        : []),
    ],
  };
};
